<template>
  <div>
    <h2>{{ title }}</h2>
    <div class="notice">
      <label style="display:block; cursor:pointer;">
        <div class="float-left">
          <input
            type="checkbox"
            v-model="acknowledged"
            @change="acknowledgeUpdated"
          />&emsp;
        </div>
        <p>{{ acknowledgementText }}</p>
      </label>
      <span class="field-validation-error" v-if="this.error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "acknowledgementText", "title", "error"],
  data() {
    return {
      acknowledged: false
    };
  },
  methods: {
    acknowledgeUpdated() {
      this.$emit("passUpdated", { name: this.name, value: this.acknowledged });
    }
  },
  name: "Acknowledgement"
};
</script>
